import React, { FC } from 'react';
import { TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from '@material-ui/core';
import BodyRow from './components/BodyRow';
import { Skeleton } from '@material-ui/lab';

interface Props {
  isLoadingData: boolean;
  isUpdate: boolean;
  checkedInvoice: InvoiceModel[];
  totalPay: number;
  otherPayments: OtherPayment[];
  payload?: PayloadPayment | null;
  invoicePending: number[];
  handleIndividualCheck: (item: { InvoiceId: number }) => void;
}

const InvoiceTable: FC<Props> = props => {
  const { isLoadingData, isUpdate, checkedInvoice, totalPay, otherPayments, payload, invoicePending, handleIndividualCheck } = props;
  return (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell align='center'></TableCell>
            <TableCell align='center'>Nomor Invoice</TableCell>
            <TableCell align='center'>Tgl Invoice</TableCell>
            <TableCell align='center'>Total Jumlah</TableCell>
            <TableCell align='right'>Jumlah Tagihan</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoadingData ? (
            <TableRow>
              <TableCell colSpan={5}>
                <Skeleton />
              </TableCell>
            </TableRow>
          ) : checkedInvoice.length > 0 ? (
            checkedInvoice.map((value, index) => (
              <BodyRow
                key={index}
                index={index}
                invoice={value}
                isLoading={isLoadingData}
                isUpdate={isUpdate}
                totalPay={totalPay}
                otherPayment={otherPayments.find(f => f.invoiceId === value.id)}
                payload={payload}
                hasPending={invoicePending.some(v => v === value.id)}
                handleIndividualCheck={handleIndividualCheck}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align='center'>
                Invoice belum tersedia
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceTable;
